import { gql } from "@apollo/client"

export const TOURNAMENT_REGISTER = gql`
  mutation TournamentRegister($TournamentRegisterInput: TournamentRegisterInput!) {
    TournamentRegister(input: $TournamentRegisterInput) {
      status {
        success
        name
        detail
      }
      tournament {
        id
        name
        urlView
      }
    }
  }
`
